export default __webpack_public_path__ + "static/media/sms-icon-landing.74820660.svg";